const underMaintenanceMessage = `The TGP Franchisee Portal is temporarily unavailable due to the Scheduled Maintenance. Please check back soon.`;

// eslint-disable-next-line import/prefer-default-export
export { underMaintenanceMessage };
